<template>
  <v-app>
    <v-app-bar app
               absolute
               style="z-index: 10000"
               >
      <v-toolbar-title class="headline text-uppercase">
        <router-link :to="'/'">
        <v-img :src="require('./assets/foraje.svg')" max-height="150" max-width="150" contain>
        </v-img>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <form @submit.prevent="BeginSearch">
        <v-text-field solo append-icon="mdi-magnify" hide-details
                      single-line light v-model="search_query"
                      class="hidden-xs-only"></v-text-field>
      </form>
     <!-- <v-menu
        right
        text
        offset-y
        close-on-content-click
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="mx-2">
            <v-icon>mdi-book</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/guide/'">
            <v-btn text>
              <v-icon light>mdi-book-information-variant</v-icon>
              Guides
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>-->
      <v-btn
        v-if="!userIsAuthenticated"
        router-link
        text
        v-bind:to="'/sign_up'"> Sign Up
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>

      <v-btn
        v-if="!userIsAuthenticated"
        router-link
        text
        v-bind:to="'/sign_in'"> Sign In
        <v-icon>mdi-login</v-icon>
      </v-btn>
      <!--<v-btn icon class="ml-4">
        <v-badge left>
          <template v-slot:badge v-if="cart_quantity > 0">{{cart_quantity}}</template>
        <v-icon>
          mdi-cart
        </v-icon>
        </v-badge>
      </v-btn>-->
      <v-menu
        v-if="userIsAuthenticated"
        right
        text
        offset-y
        close-on-content-click
      >
        <template v-slot:activator="{ on }">
        <v-btn icon light v-on="on" class="mx-2">
          <v-icon light>mdi-account-circle</v-icon>
        </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/profiles/' + this.userSlug">
            <v-btn text>
              <v-icon light>mdi-account</v-icon>
              My Profile
            </v-btn>
          </v-list-item>
          <v-list-item :to="'/forms/profiles/edit/'">
            <v-btn text>
              <v-icon light>mdi-pencil</v-icon>
              Edit My Profile
            </v-btn>
          </v-list-item>
          <v-list-item :to="'/user/account/settings'">
            <v-btn text>
              <v-icon light>mdi-cog</v-icon>
              Account Settings
            </v-btn>
          </v-list-item>
          <v-list-item :to="'/user/shops/' ">
            <v-btn text>
              <v-icon light>mdi-store</v-icon>
              My Shops
            </v-btn>
          </v-list-item>
          <v-list-item :to="'/user/my-products/' ">
            <v-btn text>
              <v-icon light>mdi-package-variant-closed</v-icon>
              My Products
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn
              text
              @click="onLogout">
              <v-icon left light>mdi-exit-to-app</v-icon>
              Logout
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main v-on:alert-emitted="AlertEmitted">
      <Alert ref="alert_component"/>
      <router-view/>
    </v-main>
    <v-footer
      color="primary"
      app
      absolute
    >
      <v-row justify="center">
        <v-btn text color="white" :to="'/'">
          Home
        </v-btn>
        <v-btn text color="white" :to="'/about/'">
          About
        </v-btn>
        <v-btn text color="white" :to="'/blog/'">
          Blog
        </v-btn>
        <v-menu
          open-on-hover
          close-on-click
          top
          text
          offset-y
        >
          <template v-slot:activator="{ on }">
          <v-btn text color="white" v-on="on">
            Policies
          </v-btn>
          </template>
          <v-list>
            <v-list-item :to="'/policies/terms'">
              <v-btn text>
                Terms And Conditions
              </v-btn>
            </v-list-item>
            <v-list-item :to="'/policies/content'">
              <v-btn text>
                Content Policy
              </v-btn>
            </v-list-item>
            <v-list-item :to="'/policies/privacy'">
              <v-btn text>
                Privacy Policy
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn text color="white" :to="'/contact/'">
          Contact Us
        </v-btn>

        <v-col class="py-3 text-center white--text" cols="12" >
          &copy;2020 — <strong>Foraje</strong><div class="white--text ml-3">
          Grow. Share. Trade.
        </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Alert from './components/miscellaneous/Alert.vue';

export default {
  name: 'App',
  data: () => ({
    search_query: '',
    cart_quantity: 0,
    //
  }),
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.token !== null;
    },
    userSlug() {
      return this.$store.getters['user/user_slug'];
    },
  },
  components: {
    Alert,
  },
  methods: {
    AlertEmitted(alertdata) {
      this.$refs.alert_component.alert_values.push(alertdata);
      this.$refs.alert_component.alert_icon = alertdata.alert_icon;
      this.$refs.alert_component.alert_color = alertdata.alert_color;
      this.$refs.alert_component.alert_message = alertdata.alert_message;
      this.$refs.alert_component.alert_model = alertdata.alert_model;
    },
    onLogout() {
      this.$store.dispatch('UserLogout')
        .then(() => {
          this.AlertEmitted({
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Successfully logged out, come back soon!',
            alert_model: true,
          });
        })
        .then(() => {
          this.$router.push('/');
        })
        .catch(
        );
    },
    BeginSearch() {
      this.$router.push(`/search_results/${this.search_query}`);
    },
  },
};
</script>
